<h1 mat-dialog-title>Move Vehicle to Another Group</h1>

<mat-dialog-content class="dialog-content" style="position: relative">
  <p>
    Select a new group for the vehicle <b>{{data.name}}</b>:
  </p>

  <mat-radio-group
          class="form-radio-group"
          [(ngModel)]="vehicleGroup">
    @for (group of groups; track $index) {
      <mat-radio-button class="form-radio-button"
                        [value]="group">
        {{ group.title }}
      </mat-radio-button>
    }
  </mat-radio-group>

  @if (isWorking) {
    <app-ui-blocking-layer />
  }

  @if (isWorking) {
    <mat-progress-bar mode="indeterminate"
                      style="position: absolute;bottom: 0;left: 0;right: 0"></mat-progress-bar>
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-stroked-button mat-dialog-close [disabled]="isWorking">Cancel</button>
  <button mat-flat-button color="primary" (click)="saveChanges()" [disabled]="isWorking || !canMove()">
    Move
  </button>
</mat-dialog-actions>
